import React from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';

interface GoogleLoginComponentProps {
  googleSignIn: (data: {
    credential: string;
    clientId: string;
    targetCommunityId?: number;
    targetCircleId?: number | null;
    targetTags?: string[] | null;
  }) => void;
  targetCommunityId?: number;
  targetCircleId?: number | null;
  targetTags?: string[] | null;
}

const GoogleLoginComponent: React.FC<GoogleLoginComponentProps> = ({
  googleSignIn,
  targetCommunityId,
  targetCircleId,
  targetTags,
}) => {
  return (
    <GoogleOAuthProvider clientId="22494997878-pdubreisbu0th8mk26ge1fdgqr2kvdhl.apps.googleusercontent.com">
      <GoogleLogin
        onSuccess={({ credential = '', clientId = '' }) => {
          googleSignIn({ credential, clientId, targetCommunityId, targetCircleId, targetTags });
        }}
        onError={() => {
          console.log('Login Failed');
        }}
        logo_alignment="center"
        containerProps={{ style: { width: '100%' } }}
        useOneTap
        text="continue_with"
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginComponent;
